import {Model} from "./Model";

export class Course extends Model {
    name;
    description;
    topics;
}